import request from './request'

function transformRequest(data: any) {
	const {
		address = [],
		company_region = [],
		company_type,
		bid_type,
		main_body,
		...rest
	} = data
	// 非必填项要传空值
	return {
		person_mobile: '',
		company_url: '',
		customer_tel: '',
		person_card_type: '',
		person_idcard: '',
		person_email: '',
		...rest,
		bid_type,
		main_body: 1,
		...(bid_type === 7 && {
			bid_type: 2,
			main_body: 2,
		}),
		...(bid_type === 8 && {
			bid_type: 2,
			main_body: 3,
		}),
		license_province: address[0],
		license_city: address[1],
		license_area: address[2],
		company_province: company_region[0],
		company_city: company_region[1],
		company_area: company_region[2],
		...(company_type && { company_type: company_type.join(',') }),
	}
}

function transformResponse({ bus_user, bus_info }: any) {
	const data = { ...bus_user, ...bus_info }
	const {
		license_province,
		license_city,
		license_area,
		company_province,
		company_city,
		company_area,
		company_type,
	} = data
	data.address = [license_province, license_city, license_area].filter(
		Boolean
	)
	data.company_region = [company_province, company_city, company_area].filter(
		Boolean
	)
	data.company_type = company_type ? company_type.split(',') : []

	return data
}

/** 查询公司信息 */
export function queryCompanyInfo() {
	return request
		.get('/api/business_join/queryCompanyInfo')
		.then(transformResponse)
}

/** 校验公司名 */
export function validateCompany(name: string) {
	return request
		.get(`/api/business_join/checkBlackCompanyName?company_name=${name}`)
}

/** 保存公司信息 */
export function saveCompanyInfo(data: any) {
	return request.post(
		'/api/business_join/saveCompanyInfo',
		transformRequest(data)
	)
}

/** 查询采购员列表接口 */
export function queryPurchaseList() {
	return request.get('/api/business_join/queryPurchaseList')
}

/** 营业执照识别接口 */
export function queryBusinessLicenseInfo(img_url: string) {
	return request.get(`/api/ocr/businessLicense?img_url=${img_url}`)
}

/** 身份证识别接口 */
export function queryIdCardInfo({ img_url, card_side }: { img_url: string, card_side: string }) {
	return request.get(`/api/ocr/idCard?img_url=${img_url}&card_side=${card_side}`)
}

/** 人脸认证结果查询接口 */
export function queryFaceResult(verify_token: string) {
	return request({
		method: 'GET',
		url: `/api/ocr/faceResultQuery?verify_token=${verify_token}&t=${Date.now()}`,
		reportError: false,
	})
}

/** 人脸认证用户信息上报接口 */
export function queryFaceIdCardInfo(data: {
	id_name: string
	id_no: string
	certificate_type: number
}) {
	return request.post(`/api/ocr/faceIdCardSubmit`, data)
}

